import moment from 'moment'

const currencyFormatter = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
})

export const formatCurrency = (value = 0) => currencyFormatter.format(Number(value || 0))

export const formatLongDate = (value) => value ? moment(value).format('dddd Do MMMM YYYY') : ''

export const formatShortDate = (value) => value ? moment(value).format('ddd D MMM') : ''

export const formatMonth = (value) => value ? moment(value).format('MMMM YYYY') : ''

export const formatTime = (value) => value ? moment(value).format('h:mma') : ''

export const normaliseParticipantKey = (label = '') => {
  const value = String(label).toLowerCase()

  if (value.includes('adult')) return 'adults'
  if (value.includes('child')) return 'children'
  if (value.includes('senior')) return 'seniors'
  if (value.includes('infant')) return 'infants'
  if (value.includes('spectator')) return 'spectators'

  return value.replace(/\s+/g, '_')
}

export const humaniseParticipantKey = (key = '') => {
  const value = String(key)

  if (value === 'adults') return 'Adults'
  if (value === 'children') return 'Children'
  if (value === 'seniors') return 'Seniors'
  if (value === 'infants') return 'Infants'
  if (value === 'spectators') return 'Spectator'

  return value.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
}
